<template>
<div class="z-30 fixed w-full h-full pl-56 pt-20 top-0 left-0">
  <div
    ref="modalbg"
    class="z-30 w-full h-full text-center bg-black/50"
    @click="checkClosing($event)"
  >
    <div class="w-full h-full relative">
      <div
        ref="modalcontent"
        class="z-40 center w-11/12 -ml-16 sm:w-1/2 2xl:w-1/4 text-left bg-white rounded-3xl"
      >
        <div class="w-full h-full relative inline-block">
          <div
            @click="$emit('closeNotification')"
            class="iconborder-modal z-50"
          >
            <font-awesome-icon size="lg" icon="xmark" class="inborder" />
          </div>
          <div class="w-full h-full p-8 px-14">
            <div class="w-full text-center">
              <span class="font-bold text-2xl"
                >Einen Job auswählen</span
              >
              <div class="mt-8">
                <input
                  v-model="filter"
                  class="block border-b-2 mb-2"
                  placeholder="Filter nach Titel"
                />
                <div class="overflow-y">
                  <span v-if="filteredJobs.length == 0" class="text-red-500"
                    >Keine Jobs gefunden</span
                  >
                  <button
                    class="m-1"
                    v-for="job in filteredJobs"
                    :key="job"
                    v-bind:class="{ positive: job == currentJob }"
                    @click="currentJob = job"
                  >
                    {{ job.title }}
                  </button>
                </div>
              </div>
              <div class="mt-5">
                <button v-if="currentJob" class="positive" @click="confirm()">
                  Auswählen
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <input
        type="file"
        id="newApplicationFileUpload"
        @change="prepareUploadFile()"
        hidden
      />
    </div>
    </div>
  </div>
</template>

<script>
import { useCookies } from "vue3-cookies";
import API from "@/API/Business";

export default {
  setup() {
    const { cookies } = useCookies();
    return { cookies };
  },
  props: {
  },
  data() {
    return {
      filter: "",
      jobs: [],
      currentJob: false,
    };
  },
  methods: {
    confirm() {
      this.$emit('jobChosen', this.currentJob);
    },
    checkClosing(event) {
            if (event.target == this.$refs.modalbg) {
        this.$emit("closeNotification");
      }
    },
  },
  computed: {
    filteredJobs: function () {
      return this.jobs.filter((job) => job.title.toLowerCase().includes(this.filter.toLowerCase()));
    },
  },
  created: function () {
    let vm = this;
    API.getJobs((jobs) => {
      vm.jobs = jobs.filter((job) => job.title!="Postfach-Integration");
    });
  },
};
</script>

<style scoped>
</style>
